// // import { subPlanAdd } from './actions';
// import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
// import { subPlanList, subPlanAdd, subPlanDelete } from '../../helpers/api';

// import {
//     subPlanListSuccess,
//     subPlanAddSuccess,
//     subPlanDeleteSuccess,
//     subPlanListError,
//     subPlanAddError,
//     subPlanDeleteError,
// } from './actions';

// import { SubsAndPlansActionTypes } from './constants';
// import { SagaIterator } from 'redux-saga';

// function* subPlanListSaga(action: any): SagaIterator {
//     try {
//         const response = yield call(subPlanList, action.payload);
//         yield put(subPlanListSuccess(response.data.message));
//     } catch (error: any) {
//         yield put(subPlanListError(error.message || 'Error Occurred'));
//     }
// }

// function* subPlanDeleteSaga(action: any): SagaIterator {
//     try {
//         const response = yield call(subPlanDelete, action.payload);
//         yield put(subPlanDeleteSuccess(response.data.message));
//     } catch (error: any) {
//         yield put(subPlanDeleteError(error.message || 'Error Occurred'));
//     }
// }

// function* subPlanAddSaga(action: any): SagaIterator {
//     try {
//         const response = yield call(subPlanAdd, action.payload);
//         yield put(subPlanAddSuccess(response.data.message));
//     } catch (error: any) {
//         yield put(subPlanAddError(error.message || 'Error Occurred'));
//     }
// }

// function* watchSubPlanList() {
//     yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST, subPlanListSaga);
// }

// function* watchSubPlanAdd() {
//     yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD, subPlanAddSaga);
// }

// function* watchSubPlanDelete() {
//     yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE, subPlanDeleteSaga);
// }

// export default function* SubAndPlansSaga() {
//     yield all([fork(watchSubPlanList), fork(watchSubPlanAdd), fork(watchSubPlanDelete)]);
// }

// src/redux/subscriptionsAndPlans/saga.ts
import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import {
    subPlanList,
    subPlanAdd,
    subPlanDelete,
    subPlanUpdate,
    subPlanUpdateStatus,
    subList,
    subAdd,
    subSchedule,
    subAddModules,
} from '../../helpers/api';

import {
    subPlanListSuccess,
    subPlanAddSuccess,
    subPlanDeleteSuccess,
    subPlanUpdateSuccess,
    subPlanUpdateStatusSuccess,
    subListSuccess,
    subPlanListError,
    subPlanAddError,
    subPlanDeleteError,
    subPlanUpdateError,
    subPlanUpdateStatusError,
    subListError,
    subAddSuccess,
    subAddError,
    subScheduleSuccess,
    subScheduleError,
    subAddModulesSuccess,
    subAddModulesError,
} from './actions';

import { SubsAndPlansActionTypes } from './constants';
import { SagaIterator } from 'redux-saga';

function* subPlanListSaga(action: any): SagaIterator {
    try {
        const response = yield call(subPlanList, action.payload);

        const data = response.data?.data;

        const plans = (data?.plans || []).map((plan: any) => ({
            ...plan,
            price: plan.price ?? '0',
            max_users: plan.max_users ?? '0',
            max_outlets: plan.max_outlets ?? '0',
        }));

        yield put(
            subPlanListSuccess({
                plans, // flat array
                page: data?.page || 1,
                totalPages: data?.totalPages || 1,
            })
        );
    } catch (error: any) {
        yield put(subPlanListError(error.message || 'Error Occurred'));
    }
}

function* subListSaga(action: any): SagaIterator {
    try {
        const response = yield call(subList, action.payload);

        const data = response.data?.data?.outlets;
        console.log('data>>>', data);

        yield put(
            subListSuccess({
                data,
            })
        );
    } catch (error: any) {
        yield put(subListError(error || 'Error Occurred'));
    }
}

function* subPlanAddSaga(action: any): SagaIterator {
    try {
        const response = yield call(subPlanAdd, action.payload);
        console.log(response);

        yield put(subPlanAddSuccess(response.data.message));
    } catch (error: any) {
        yield put(subPlanAddError(error.message || 'Error Occurred'));
    }
}

function* subAddSaga(action: any): SagaIterator {
    try {
        const response = yield call(subAdd, action.payload);
        console.log(response);
        yield put(subAddSuccess(response.data.message));
        yield put({ type: SubsAndPlansActionTypes.RESET_SUB_SUCCESS });
    } catch (error: any) {
        yield put(subAddError(error || 'Error Occurred'));
    }
}

function* subScheduleSaga(action: any): SagaIterator {
    try {
        const response = yield call(subSchedule, action.payload);
        console.log(response);
        yield put(subScheduleSuccess(response.data.message));
        yield put({ type: SubsAndPlansActionTypes.RESET_SUB_SUCCESS });
    } catch (error: any) {
        yield put(subScheduleError(error || 'Error Occurred'));
    }
}

function* subPlanDeleteSaga(action: any): SagaIterator {
    try {
        const response = yield call(subPlanDelete, action.payload);
        yield put(subPlanDeleteSuccess(response.data.message));
    } catch (error: any) {
        yield put(subPlanDeleteError(error.message || 'Error Occurred'));
    }
}

function* subPlanUpdateSaga(action: any): SagaIterator {
    try {
        const response = yield call(subPlanUpdate, action.payload);
        yield put(subPlanUpdateSuccess(response.data.message));
    } catch (error: any) {
        yield put(subPlanUpdateError(error.message || 'Error Occurred'));
    }
}

function* subAddModulesSaga(action: any): SagaIterator {
    try {
        const response = yield call(subAddModules, action.payload);
        yield put(subAddModulesSuccess(response.data.message));
    } catch (error: any) {
        yield put(subAddModulesError(error || 'Error Occurred'));
    }
}

function* subPlanUpdateStatusSaga(action: any): SagaIterator {
    console.log('here?');

    try {
        const response = yield call(subPlanUpdateStatus, action.payload);
        yield put(subPlanUpdateStatusSuccess(response.data.message));
    } catch (error: any) {
        yield put(subPlanUpdateStatusError(error.message || 'Error Occurred'));
    }
}

function* watchSubPlanList() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST, subPlanListSaga);
}
function* watchSubPlanAdd() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD, subPlanAddSaga);
}
function* watchSubAdd() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_ADD, subAddSaga);
}
function* watchSubSchedule() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE, subScheduleSaga);
}
function* watchSubPlanDelete() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE, subPlanDeleteSaga);
}
function* watchSubPlanUpdate() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE, subPlanUpdateSaga);
}
function* watchSubPlanUpdateStatus() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS, subPlanUpdateStatusSaga);
}
function* watchSubList() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_LIST, subListSaga);
}
function* watchSubAddModules() {
    yield takeEvery(SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES, subAddModulesSaga);
}
/**
 * Root Saga
 */
export default function* SubAndPlansSaga() {
    yield all([
        fork(watchSubPlanList),
        fork(watchSubPlanAdd),
        fork(watchSubPlanDelete),
        fork(watchSubPlanUpdate),
        fork(watchSubPlanUpdateStatus),
        fork(watchSubList),
        fork(watchSubAdd),
        fork(watchSubSchedule),
        fork(watchSubAddModules),
    ]);
}
